import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { List, Map, fromJS } from "immutable";
import { createSelector } from "reselect";
import { fromDotNotation, toDotNotation } from "../util/ams.js";
import { mapKeys, stripUndefinedValues } from "../util/object.js";
import { trim } from "../util/string.js";
import { validateRulesAndValues } from "../util/validation.js";
import { toValidationRule } from "../util/validation_rules.js";
import { accountTypes } from "./constants.js";
import { newGetFormConfigurations } from "../config/store.js";
export function userReducer() {
  var _action$payload;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var profile = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.profile;
  var user = state !== null && state !== void 0 && state.user ? _objectSpread({}, state.user) : {};
  switch (action.type) {
    case "USER/LOGIN_LOADED":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loginError: null,
          user: _objectSpread(_objectSpread({}, user), {}, {
            loggedIn: action.payload.loggedIn,
            profile: profile
          }),
          showCaptcha: false,
          captchaErrorMessage: null,
          guestAccountNotUniqueError: -1
        });
        // .delete("loginError")
        // .setIn(["user", "loggedIn"], action.payload.loggedIn)
        // .setIn(["user", "profile"], fromJS(action.payload.profile));
      }
    case "USER/USER_LOGGED_OUT":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          user: _objectSpread(_objectSpread({}, user), {}, {
            loggedIn: false,
            profile: null
          }),
          captchaSiteKey: null,
          showCaptcha: false,
          creditCards: null,
          guestAccountNotUniqueError: -1
        });
      }
    // .deleteIn(["user", "profile"])
    // .delete("creditCards")
    // .setIn(["user", "loggedIn"], false);

    case "USER/CAPTCHA_SITEKEY_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        captchaSiteKey: action.payload.captchaSiteKey
      });
    case "USER/LOGIN_FAILED":
      {
        var _action$payload$error, _action$payload$error2;
        return _objectSpread(_objectSpread({}, state), {}, {
          loginError: action.payload.error,
          captchaSiteKey: (_action$payload$error = action.payload.error) === null || _action$payload$error === void 0 ? void 0 : _action$payload$error.captchaSiteKey,
          showCaptcha: ((_action$payload$error2 = action.payload.error) === null || _action$payload$error2 === void 0 ? void 0 : _action$payload$error2.captchaSiteKey) !== undefined ? true : false
        });
      }
    case "USER/SIGN_UP_GUEST_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        guestAccountNotUniqueError: -1
      });
    case "USER/SIGN_UP_FAILED":
    case "USER/SIGN_UP_GUEST_FAILED":
    case "USER/UPDATE_PROFILE_FAILED":
    case "USER/CAPTCHA_REQUIRED":
      {
        var _action$payload$error3, _action$payload$error5;
        if (((_action$payload$error3 = action.payload.error) === null || _action$payload$error3 === void 0 ? void 0 : _action$payload$error3.type) === "CAPTCHA_REQUIRED") {
          var _action$payload$error4;
          return _objectSpread(_objectSpread({}, state), {}, {
            captchaErrorMessage: action.payload.error.displayMessage,
            captchaSiteKey: (_action$payload$error4 = action.payload.error) === null || _action$payload$error4 === void 0 ? void 0 : _action$payload$error4.captchaSiteKey
          });
        }
        if (((_action$payload$error5 = action.payload.error) === null || _action$payload$error5 === void 0 ? void 0 : _action$payload$error5.type) === "GUEST_ACCOUNT_NOT_UNIQUE") {
          return _objectSpread(_objectSpread({}, state), {}, {
            guestAccountNotUniqueError: state.guestAccountNotUniqueError + 1
          });
        } else {
          return state;
        }
      }
    case "USER/CAPTCHA_PASSED":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          captchaErrorMessage: null,
          captchaSiteKey: null,
          showCaptcha: false
        });
      }
    case "USER/CAPTCHA_SOLVED":
      return _objectSpread(_objectSpread({}, state), {}, {
        captchaErrorMessage: null,
        loginError: null
      });
    case "USER/RESET_PASSWORD_TOKEN_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        resetPasswordToken: action.payload.resetPasswordToken,
        resetPasswordAccountType: action.payload.resetPasswordAccountType
      });
    case "USER/CREDIT_CARDS_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCards: action.payload.creditCards
      });
    case "USER/FORM_CONFIGURATION_LOADED":
      {
        var formConfigurationsValues = _objectSpread({}, state === null || state === void 0 ? void 0 : state.formConfigurationsValues);
        formConfigurationsValues[action.payload.groupName] = null;
        var formConfiguration = _objectSpread({}, state === null || state === void 0 ? void 0 : state.formConfiguration);
        formConfiguration[action.payload.groupName] = action.payload.formConfiguration;
        var result = _objectSpread(_objectSpread({}, state), {}, {
          formConfigurationValues: formConfigurationsValues,
          formConfiguration: formConfiguration
        });
        return result;
      }
    //    .deleteIn(["formConfigurationValues", action.payload.groupName])
    //    .setIn(["formConfiguration", action.payload.groupName], fromJS(action.payload.formConfiguration));

    case "USER/FORM_CONFIGURATION_VALUES":
      {
        var _formConfigurationsValues = _objectSpread({}, state === null || state === void 0 ? void 0 : state.formConfigurationsValues);
        _formConfigurationsValues[action.payload.groupName] = action.payload.values;
        return _objectSpread(_objectSpread({}, state), {}, {
          formConfigurationValues: _formConfigurationsValues
        });
      }
    //state.setIn(["formConfigurationValues", action.payload.groupName], fromJS(action.payload.values));

    case "USER/SERVER_VALIDATION_FAILED":
      {
        var serverValidationResult = _objectSpread({}, state === null || state === void 0 ? void 0 : state.serverValidationResult);
        serverValidationResult[action.payload.groupName] = {
          values: action.payload.values,
          errors: action.payload.errors
        };
        var _result = _objectSpread(_objectSpread({}, state), {}, {
          serverValidationResult: serverValidationResult
        });
        // state.setIn(["serverValidationResult", action.payload.groupName], fromJS({
        //   values: action.payload.values,
        //   errors: action.payload.errors
        // }));
        return _result;
      }
    default:
      return state;
  }
}
var getUser = function getUser(state) {
  var _state$user$user, _state$user;
  return (_state$user$user = (_state$user = state.user) === null || _state$user === void 0 ? void 0 : _state$user.user) !== null && _state$user$user !== void 0 ? _state$user$user : Map();
};
export var getCaptchaSiteKey = function getCaptchaSiteKey(state) {
  var _state$user2;
  return (_state$user2 = state.user) === null || _state$user2 === void 0 ? void 0 : _state$user2.captchaSiteKey;
};
export var showCaptchaAtLogin = function showCaptchaAtLogin(state) {
  var _state$user3;
  return (_state$user3 = state.user) === null || _state$user3 === void 0 ? void 0 : _state$user3.showCaptcha;
};
export var getUserProfile = createSelector([getUser], function (user) {
  return fromJS(user === null || user === void 0 ? void 0 : user.profile);
});
export var isGuestAccountActive = createSelector([getUserProfile], function (profile) {
  var _profile$get;
  return profile && ((_profile$get = profile.get("debitor")) === null || _profile$get === void 0 ? void 0 : _profile$get.get("custGrp")) === "GA";
});
var getLoginError = function getLoginError(state) {
  var _state$user4;
  return state === null || state === void 0 || (_state$user4 = state.user) === null || _state$user4 === void 0 ? void 0 : _state$user4.loginError;
};
export var getLoggedIn = createSelector(getUser, function (user) {
  return (user === null || user === void 0 ? void 0 : user.loggedIn) || false;
});
export var getLoginErrorMessage = createSelector(getLoginError, function (error) {
  return error && error.displayMessage;
});
export var getCaptchaErrorMessage = function getCaptchaErrorMessage(state) {
  var _state$user5;
  return state === null || state === void 0 || (_state$user5 = state.user) === null || _state$user5 === void 0 ? void 0 : _state$user5.captchaErrorMessage;
};
export var getGuestAccountRegisterFailed = function getGuestAccountRegisterFailed(state) {
  var _state$user6;
  return state === null || state === void 0 || (_state$user6 = state.user) === null || _state$user6 === void 0 ? void 0 : _state$user6.guestAccountNotUniqueError;
};
export var getUserEmail = createSelector([getUserProfile], function (userProfile) {
  return userProfile && userProfile.get("login");
});
export var getGuestUserEmail = createSelector([getUserProfile, isGuestAccountActive], function (userProfile, isGuestAccountActive) {
  if (userProfile) {
    if (isGuestAccountActive === true) {
      var _userProfile$get;
      return (_userProfile$get = userProfile.get("addresses")) === null || _userProfile$get === void 0 || (_userProfile$get = _userProfile$get.get(0)) === null || _userProfile$get === void 0 ? void 0 : _userProfile$get.get("email");
    }
  }
});
export var getResetPasswordToken = function getResetPasswordToken(state) {
  var _state$user7;
  return state === null || state === void 0 || (_state$user7 = state.user) === null || _state$user7 === void 0 ? void 0 : _state$user7.resetPasswordToken;
};
export var getResetPasswordAccountType = function getResetPasswordAccountType(state) {
  var _state$user8;
  return (state === null || state === void 0 || (_state$user8 = state.user) === null || _state$user8 === void 0 ? void 0 : _state$user8.resetPasswordAccountType) || accountTypes.B2C;
};
export var getPlainCreditCards = function getPlainCreditCards(state) {
  var _state$user9;
  return state === null || state === void 0 || (_state$user9 = state.user) === null || _state$user9 === void 0 ? void 0 : _state$user9.creditCards;
};
export var getCreditCards = createSelector([getPlainCreditCards], function (creditCards) {
  return creditCards ? fromJS(creditCards) : List();
});

// ======================================================================
// Form configuration
// ======================================================================

var newTheirNameToOurName = function newTheirNameToOurName(groupName) {
  return createSelector([newGetFormConfigurations(groupName)], function (mappings) {
    return function (theirName) {
      var match = mappings.find(function (mapping) {
        return mapping.first() === theirName;
      });
      return match ? match.get(1) : fromDotNotation(theirName.replace(/\.\d+$/, ""));
    };
  });
};
var getRawFormConfiguration = function getRawFormConfiguration(state) {
  var _state$user10;
  return state === null || state === void 0 || (_state$user10 = state.user) === null || _state$user10 === void 0 ? void 0 : _state$user10.formConfiguration;
};
var getUserFormConfiguration = createSelector([getRawFormConfiguration], function (formConfiguration) {
  return formConfiguration ? fromJS(formConfiguration) : Map();
});
var newUserFormConfiguration = function newUserFormConfiguration(groupName) {
  return createSelector([getUserFormConfiguration], function (formConfigurations) {
    return formConfigurations.get(groupName) || List();
  });
};
var newFormFieldList = function newFormFieldList(groupName) {
  return createSelector([newUserFormConfiguration(groupName), newTheirNameToOurName(groupName)], function (formConfiguration, theirNameToOurName) {
    return formConfiguration.flatMap(function (fieldset) {
      return fieldset.get("items");
    }).map(function (item) {
      return item.set("_nameOriginal", item.get("name")).set("_nameWithSuffix", fromDotNotation(item.get("name"))).set("_nameWithoutSuffix", theirNameToOurName(item.get("name"))).update("name", theirNameToOurName);
    });
  });
};

// AMS form field names have the form "Object.property.suffix"
// (e.g. "Customer.name.123"). We need to both map "Customer.password"
// to "Customer.password.107" (SignUp) and "Customer.password.129"
// (SignUpConfirmed) as well as use field names with suffix for the
// boolean flags "ABDynDataValue.valueBoolean.108",
// "ABDynDataValue.valueBoolean.111" etc.
//
// The extended form field list contains each field twice (with and
// without suffix)
var newExtendedFormFieldList = function newExtendedFormFieldList(groupName) {
  return createSelector([newFormFieldList(groupName)], function (formFieldList) {
    return formFieldList.reduce(function (fields, field) {
      return fields.push(field.set("name", field.get("_nameWithSuffix"))).push(field.set("name", field.get("_nameWithoutSuffix")));
    }, List());
  });
};
var newFormFieldMap = function newFormFieldMap(groupName) {
  return createSelector([newExtendedFormFieldList(groupName)], function (formFieldList) {
    return formFieldList.reduce(function (fields, field) {
      return fields.set(field.get("name"), field);
    }, Map());
  });
};
var newGetFormField = function newGetFormField(groupName) {
  return createSelector([newFormFieldMap(groupName)], function (formFieldMap) {
    return function (fieldName) {
      return formFieldMap.get(fieldName, Map());
    };
  });
};
export var newGetSelectFieldOptions = function newGetSelectFieldOptions(groupName) {
  return createSelector([newGetFormField(groupName)], function (getFormField) {
    return function (fieldName) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$includeEmptyOpti = _ref.includeEmptyOption,
        includeEmptyOption = _ref$includeEmptyOpti === void 0 ? true : _ref$includeEmptyOpti;
      var field = getFormField(fieldName);
      var options = field.get("data", List()).map(function (option) {
        return option.update("key", trim);
      });
      var emptyText = field.get("emptyText");
      return includeEmptyOption ? options.unshift(Map({
        key: "",
        value: emptyText
      })).toJS() : options.toJS();
    };
  });
};
var newGetFormValidationRules = function newGetFormValidationRules(groupName) {
  return createSelector([newExtendedFormFieldList(groupName)], function (formFieldList) {
    return formFieldList.toJS().reduce(toValidationRule, {});
  });
};
var getRawServerValidationResult = function getRawServerValidationResult(state) {
  var _state$user11;
  return (_state$user11 = state.user) === null || _state$user11 === void 0 ? void 0 : _state$user11.serverValidationResult;
};
var getServerValidationErrorResult = createSelector([getRawServerValidationResult], function (serverValidationResult) {
  return serverValidationResult ? fromJS(serverValidationResult) : Map();
});
var newGetRawServerValidationResult = function newGetRawServerValidationResult(groupName) {
  return createSelector([getServerValidationErrorResult], function (serverValidationResult) {
    return serverValidationResult.get(groupName, Map());
  });
};
var newGetServerValidationErrors = function newGetServerValidationErrors(groupName, nameMap) {
  return createSelector([newGetRawServerValidationResult(groupName), newTheirNameToOurName(groupName)], function (serverValidationResult, theirNameToOurName) {
    return function (values) {
      var errors = serverValidationResult.get("errors", Map()).mapEntries(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          name = _ref3[0],
          value = _ref3[1];
        return [nameMap[fromDotNotation(name)] || theirNameToOurName(name), value];
      });
      var oldValues = serverValidationResult.get("values");
      return errors.entrySeq().filter(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
          name = _ref5[0];
        return name in values && oldValues.get(name) === values[name];
      });
    };
  });
};
export var newValidate = function newValidate(groupName) {
  var nameMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createSelector([newGetFormValidationRules(groupName), newGetServerValidationErrors(groupName, nameMap)], function (validationRules, getServerValidationErrors) {
    return function (values) {
      var serverErrors = getServerValidationErrors(values);
      var clientErrors = validateRulesAndValues(validationRules)(values);
      var errors = Map().merge(serverErrors).merge(clientErrors).toJS();

      // Remove 'undefined' values from errors object because Formik
      // interprets presence of keys as errors regardless of value
      return stripUndefinedValues(errors);
    };
  });
};
var newGetFormFieldProperty = function newGetFormFieldProperty(groupName, property, defaultFallback) {
  var transform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (value) {
    return value;
  };
  return createSelector([newGetFormField(groupName)], function (getFormField) {
    return function (fieldName, fallback) {
      return transform(getFormField(fieldName).get(property, defaultFallback !== undefined ? defaultFallback : fallback));
    };
  });
};
var getRawFormConfigurationValues = function getRawFormConfigurationValues(state) {
  return state === null || state === void 0 ? void 0 : state.user.formConfigurationValues;
};
var getFormConfigurationvalues = createSelector([getRawFormConfigurationValues], function (formConfigurationValues) {
  return formConfigurationValues ? fromJS(formConfigurationValues) : Map();
});
var newGetFormFieldOverriddenValue = function newGetFormFieldOverriddenValue(groupName) {
  return createSelector([getFormConfigurationvalues], function (values) {
    return function (fieldName) {
      return values.getIn([groupName, fieldName]);
    };
  });
};
var newGetFormFieldDefaultValue = function newGetFormFieldDefaultValue(groupName) {
  return createSelector([newGetFormFieldProperty(groupName, "value", undefined, trim), newGetFormFieldOverriddenValue(groupName)], function (getFormFieldValue, getFormFieldOverriddenValue) {
    return function (fieldName, fallback) {
      var overriddenValue = getFormFieldOverriddenValue(fieldName);
      return overriddenValue !== undefined ? overriddenValue : getFormFieldValue(fieldName, fallback);
    };
  });
};
export var newGetInitialValues = function newGetInitialValues(groupName) {
  return createSelector([newGetFormFieldDefaultValue(groupName)], function (getDefaultValue) {
    return function (valueMap) {
      return Object.entries(valueMap).map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          fieldName = _ref7[0],
          fallback = _ref7[1];
        return [fieldName, getDefaultValue(fieldName, fallback)];
      }).reduce(function (defaultValues, _ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          fieldName = _ref9[0],
          defaultValue = _ref9[1];
        return _objectSpread(_objectSpread({}, defaultValues), {}, _defineProperty({}, fieldName, defaultValue));
      }, {});
    };
  });
};
export var newHasField = function newHasField(groupName) {
  return createSelector([newFormFieldMap(groupName)], function (formFieldMap) {
    return function (fieldName) {
      return formFieldMap.has(fieldName);
    };
  });
};
export var newGetFieldLabel = function newGetFieldLabel(groupName) {
  return newGetFormFieldProperty(groupName, "fieldLabel", "");
};
export var newGetFieldPlaceholder = function newGetFieldPlaceholder(groupName) {
  return newGetFormFieldProperty(groupName, "emptyText");
};
export var newIsFieldRequired = function newIsFieldRequired(groupName) {
  return newGetFormFieldProperty(groupName, "allowBlank", true, function (allowBlank) {
    return !allowBlank;
  });
};
var newGetFormFieldNameMap = function newGetFormFieldNameMap(groupName) {
  return createSelector([newFormFieldList(groupName)], function (formFieldList) {
    return formFieldList.map(function (item) {
      return [item.get("_nameWithoutSuffix"), item.get("_nameOriginal")];
    }).reduce(function (fieldNames, _ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
        ourName = _ref11[0],
        theirName = _ref11[1];
      return fieldNames.set(ourName, theirName);
    }, Map());
  });
};
var newMapFormFieldName = function newMapFormFieldName(groupName) {
  return createSelector([newGetFormFieldNameMap(groupName)], function (formFieldNameMap) {
    return function (fieldName) {
      return formFieldNameMap.get(fieldName) || toDotNotation(fieldName);
    };
  });
};
export var newMapFormValues = function newMapFormValues(groupName) {
  return createSelector([newMapFormFieldName(groupName)], function (mapFormFieldName) {
    return function (formValues) {
      return mapKeys(formValues, mapFormFieldName);
    };
  });
};